import type { FaireProductEntity } from "../../entity_types/product";

export const p_tdf75k3h2b: FaireProductEntity = {
  token: "p_tdf75k3h2b",
  type: "product",
  name: "THE NET.ZERO MODERN FISHERMAN CROSSBODY BAG / COBALT",
  brandToken: "b_eywdt5usqy",
  brandName: "BYBBA",
  imageUrl: "https://cdn.faire.com/fastly/ac450fbdd23521c2b6739a84e04b6812c366fc39f67a0968b61589442042b693.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d8cc8bf7c722eefe9063d2f9aa88cad6ae3c78a59e33f3f39f1cef6918832f8.png",
    "https://cdn.faire.com/fastly/7455a14adaf97603c0509340aaa74265e3ecf3cf1664ea80976c205dc7338d87.png",
    "https://cdn.faire.com/fastly/774b718e36b29000cc31224c219873b86c8dff292d737baeae665202b6c1993f.png",
    "https://cdn.faire.com/fastly/e078ccf84ab2ea9c3e4ec66720b7a0e0b73d1610fb5ee7961b4110bd2ac8c28c.png",
    "https://cdn.faire.com/fastly/9a4d6e8822fa90a807b9a0411aa76be738b6030b65a47b702b178db81760b927.png",
    "https://cdn.faire.com/fastly/91766be55138b927506696ad244ad03e6759833aa47a078e4986f16306ba8dbb.png",
    "https://cdn.faire.com/fastly/ca3a7b613345ba52e7b71a41999a8590c2467a7c539f2cf8e3258fb25c75af60.jpeg",
    "https://cdn.faire.com/fastly/4aad95af22d5d7b9d3312fe74bffb04ec2047c0e90b20d7e1010514d32a854e1.png",
    "https://cdn.faire.com/fastly/e3aa6744bcb7819e067b737899f9d3fb78fbb555be88c81ec730e2f1d7efbdc7.png"
  ],
  priceDollars: 24.5,
  description: "Modern Mesh!\n\nWorn as a cross-body or on your shoulder, The Net.Zero is a weightless, breathable and durable day bag designed with durability at the forefront. Made from recycled ocean plastic and fishing net, we've combined our signature rope detail and overall quality and metal hardware to infuse style and function. Two inside pockets on either side make it easy to stash your water bottle and phone.\n\nPerfect for the farmer’s market, bike ride or beach, this hands-free, updated classic is your new go-to bag. Just another way to replace disposable bags while keeping it chic!\n\nThe Net.Zero is packed inside an organic 100% recycled cotton drawstring pouch intended for use inside or on it's own.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:51.163Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
